<template>
	<div id="publicity">
		<div class="pc" v-if="pc">
			<!--<div class="logoTop flexY">
				<a class="logo" href="http://www.ax168.com">
					<img src="/static/img/logo.png" alt="智慧农贸" />
					<div class="xian"></div>
					<div class="logoR">
						<p>国家高新技术企业</p>
						<p>全栈追溯技术服务商</p>
					</div>
				</a>
			</div>-->

			<div class="focuImg" ref="element">
				<div v-for="(item,index) in imgText" :class="[item.classname,item.show?'active':'']" v-text="item.text"></div>
				<img style="width: 100%;min-width: 1200px;" src="/static/img/home_img_banner.png" alt="智慧农贸" />
			</div>
			<div v-if="navBarFixed == true" style="height: 68px;"></div>

        <ul class="TopNav" :class="navBarFixed == true ? 'navBarWrap' :''">
        	<li :class="TopNav==1?'active':''" @click="goAnchor('#a')">
        		功能模块
        	</li>
        	<li :class="TopNav==2?'active':''" @click="goAnchor('#b')">
        		智能硬件
        	</li>
        	<li :class="TopNav==3?'active':''" @click="goAnchor('#c')">
        		客户案例
        	</li>
        	<li :class="TopNav==4?'active':''" @click="goAnchor('#d')">
        		解决方案定制
        	</li>
        	<li :class="TopNav==5?'active':''" @click="goAnchor('#e')">
        		一站式服务
        	</li>
        </ul>

			<a class="content2 flexY content1  mokuai" ref="a">
				<div class="mddw" id="a"></div>
				<div class="x">
					<p class="biaoti">100+功能模块自由组合</p>
					<ul class="iocBox">
						<li v-for="(item,index) in iocBox" :key="'iocBox'+index">
							<img :src="item.src" alt="智慧农贸" />
							<p v-text="item.name"></p>
						</li>
					</ul>
					<a v-if="!gengduo" class="gengduo" @click="clickGengduo()">更多<img style="width: .05rem;" src="/static/img/icon_down@2x.png" alt="智慧农贸" /></a>
					<a v-if="gengduo" class="gengduo" @click="clickGengduo()">收起<img style="width: .05rem;" src="/static/img/icon_up@2x.png" alt="智慧农贸" /></a>
				</div>

			</a>

			<a class="content2 flexY content1 bjh zuhe" ref="b">
				<div class="mddw" id="b"></div>
				<div class="">
					<p class="biaoti">众多品牌智能硬件任意组合</p>
					<ul class="">
						<li>
							<div class="rioc">
								<span>豪华版</span>
								<img src="/static/img/icon_LuxuryEdition.png" alt="智慧农贸" />
							</div>
							<div class="zuheBox">
								<div><img src="/static/img/img_smp.png" alt="智慧农贸" /></div>
								<div class="rtext">
									<p>智慧农贸追溯电子秤-双面屏</p>
									<p>全功能模块集成，大大提升经营效率</p>
									<div class="tdNav">
										<div>
											<img src="/static/img/czicon.png" alt="智慧农贸" />
											<p>称重</p>
										</div>
										<div>
											<img src="/static/img/jjicon.png" alt="智慧农贸" />
											<p>计件</p>
										</div>
										<div>
											<img src="/static/img/syicon.png" alt="智慧农贸" />
											<p>收银</p>
										</div>
										<div>
											<img src="/static/img/zficon.png" alt="智慧农贸" />
											<p>支付</p>
										</div>
									</div>
								</div>
							</div>
						</li>
						<li>
							<div class="rioc" style="padding-left: 10px;width: 142px;">
								<span>长续航至尊版</span>
								<img src="/static/img/icon_ZhizunEdition.png" alt="智慧农贸" />
							</div>
							<div class="zuheBox">
								<div class="rtext" style="margin-left: 0;">
									<p>智慧农贸追溯电子秤-液晶屏</p>
									<p>高性价比，解决行业普遍难题</p>
									<div class="tdNav">
										<div>
											<img src="/static/img/icon_cp.png" alt="智慧农贸" />
											<p>彩屏</p>
										</div>
										<div>
											<img src="/static/img/icon_fs.png" alt="智慧农贸" />
											<p>防水</p>
										</div>
										<div>
											<img src="/static/img/icon_xh.png" alt="智慧农贸" />
											<p>续航</p>
										</div>
										<div>
											<img src="/static/img/icon_yybb.png" alt="智慧农贸" />
											<p>语音播报</p>
										</div>
									</div>
								</div>

								<div style="margin-left: 84px;"><img style="width: 341px;height: 315px;" src="/static/img/img_yjp.png" alt="智慧农贸" /></div>
							</div>
						</li>

						<li>
							<div class="rioc" style="width: 162px;font-size: 14px;padding-left:20px;">
								<span>超长续航智享版</span>
								<img src="/static/img/icon_ZhixingEdition.png" alt="智慧农贸" />
							</div>
							<div class="zuheBox">
								<div><img style="width: 359px;height: 329px;" src="/static/img/img_jdk.png" alt="智慧农贸" /></div>
								<div class="rtext" style="margin-left: 104px;">
									<p>智慧农贸追溯电子秤-经典款</p>
									<p>省时省力，让生意更好做</p>
									<div class="tdNav">
										<div>
											<img src="/static/img/icon_fs.png" alt="智慧农贸" />
											<p>防水</p>
										</div>
										<div>
											<img src="/static/img/icon_xh.png" alt="智慧农贸" />
											<p>超长续航</p>
										</div>
										<div>
											<img src="/static/img/icon_yybb.png" alt="智慧农贸" />
											<p>语音播报</p>
										</div>
									</div>
								</div>
							</div>
						</li>
						<li>
							<div class="rioc" style="padding-left: 10px;width: 142px;">
								<span>长续航至尊版</span>
								<img src="/static/img/icon_ZhizunEdition.png" alt="智慧农贸" />
							</div>
							<div class="zuheBox">
								<div class="rtext" style="margin-left: 0;">
									<p>智慧农批追溯磅秤</p>
									<p>称重高效，账目清晰，管理放心</p>
									<div class="tdNav">
										<div>
											<img src="/static/img/npzsc_icon_czjj.png" alt="智慧农贸" />
											<p>称重计价</p>
										</div>
										<div>
											<img src="/static/img/npzsc_icon_yssy.png" alt="智慧农贸" />
											<p>验收溯源</p>
										</div>
										<div>
											<img src="/static/img/npzsc_icon_czdj.png" alt="智慧农贸" />
											<p>超长待机</p>
										</div>
										<div>
											<img src="/static/img/npzsc_icon_ydcc.png" alt="智慧农贸" />
											<p>云端存储</p>
										</div>
									</div>
								</div>

								<div style="margin-left: 84px;"><img style="width: 341px;height: 315px;" src="/static/img/img_npzsc.png" alt="智慧农贸" /></div>
							</div>
						</li>
<li>
							<div class="zuheBox">
								<div><img style="width:391px;height: 314px;" src="/static/img/img_ouchscreen.png" alt="智慧农贸" /></div>
								<div class="rtext" style="margin-left: 101px;">
									<p>放心农贸触摸一体机</p>
									<p>农贸数据化，精准化</p>
									<div class="tdNav">
										<div>
											<img src="/static/img/icon_ycz.png" alt="智慧农贸" />
											<p>易操作</p>
										</div>
										<div>
											<img src="/static/img/icon_rxh.png" alt="智慧农贸" />
											<p>人性化</p>
										</div>
										<div>
											<img src="/static/img/icon_fyk.png" alt="智慧农贸" />
											<p>反应快</p>
										</div>
									</div>
								</div>
							</div>
						</li>
						<li>
							<div class="zuheBox">
								<div class="rtext" style="margin-left: 0;">
									<p>商户信用公示屏</p>
									<p>信息公示化，透明化</p>
									<div class="tdNav">
										<div>
											<img src="/static/img/icon_jyks.png" alt="智慧农贸" />
											<p>交易可视</p>
										</div>
										<div>
											<img src="/static/img/icon_hdty.png" alt="智慧农贸" />
											<p>互动体验</p>
										</div>
									</div>
								</div>

								<div style="margin-left:232px;"><img style="width: 473px;height:259px;" src="/static/img/img_Merchantscreen.png" alt="智慧农贸" /></div>
							</div>
						</li>


						<li>
							<div class="zuheBox">
								<div ><img style="width:492px;height:300px;margin-top: 40px;" src="/static/img/img_Datascreen.png" alt="智慧农贸" /></div>
								<div class="rtext" style="margin-left:74;">
									<p>数据大屏</p>
									<p>数据可视化分析，提高决策效率</p>
									<div class="tdNav">
										<div>
											<img src="/static/img/icon_zn.png" alt="智慧农贸" />
											<p>智能</p>
										</div>
										<div>
											<img src="/static/img/icon_sjfxs.png" alt="智慧农贸" />
											<p>数据分析</p>
										</div>
										<div>
											<img src="/static/img/icon_ksh.png" alt="智慧农贸" />
											<p>可视化</p>
										</div>
									</div>
								</div>


							</div>
						</li>
					</ul>
				</div>
			</a>
			<a class="content2 flexY content1 anli" style="padding-bottom: 0;" ref="c">
				<div class="mddw" id="c"></div>
				<div class="x">
					<p class="biaoti">他们都已升级智慧农贸</p>
					<ul class="iocBox">
						<li v-for="(item,index) in anli" :key="'anli'+index">
							<img :src="item.src" alt="智慧农贸" />
							<div class="bottomBox">
								<p v-text="item.name"></p>
							</div>
						</li>
					</ul>
					<a class="gengduo" href="http://www.ax168.com/market">更多案例</a>
				</div>
			</a>
			<a class="content1 flexY bjh" ref="d">
				<div class="mddw" id="d"></div>
				<div class="x">
					<p class="biaoti" style="margin-bottom: 0;">每个市场情况不同 ,数字化升级解决方案不同</p>
					<p class="fbiaoti">无论你身在何处，均能获得安宣本地化的服务体验</p>
					<div class="JJFA">
						<div class="l">
							<div class="topxian"></div>
							<p class="pTop">浙江安宣</p>
							<p class="Plist">帮助每个有意向的市场量身定制数字化升级方案；</p>
							<p class="Plist">努力实现监管者、举办者、经营者、消费者各方需求的兼容并包；</p>
							<p class="Plist">市场规模不同、经营方式不同、投 入预算不同，解决方案自然不同。</p>
						</div>
						<div>
							<img style="width: 643px;height: 595px;" src="/static/img/publicity_local.png" alt="智慧农贸" />
						</div>
					</div>
				</div>
			</a>
			<a class="content2 flexY content1  anli fuwu" ref="e">
				<div class="mddw" id="e"></div>
				<div class="x">
					<p class="biaoti">360°全方位一站式服务</p>
					<ul class="iocBox" style="justify-content: space-around;">
						<li v-for="(item,index) in fuwu" :key="'fuwu'+index">
							<img :src="item.src" alt="智慧农贸" />
							<div class="">
								<p class="p1" v-text="item.name"></p>
								<p class="p2" v-text="item.text"></p>
							</div>
						</li>
					</ul>
				</div>
			</a>

			<!--<div class="lianxi">
				<div>
					<p>现在联系我们，赢战智慧农贸新时代！</p>
				</div>
			</div>-->
			<!--<footer style="background-color:#162037;">
				<div class="company_info">
					<div class="company_infoDetail">
						<div class="company_infoDetail_logo">
							<a href="http://www.ax168.com/"><img src="http://img.anxuan360.com/FoQIVULX9wIZZ6_BrVvJAlkPaUMp" alt="智慧农贸"></a>
						</div>
						<div class="company_infoDetail_text">地址：浙江省杭州市西湖区西园八路11号一期D座506-507</div>
						<div class="company_infoDetail_text">
							<a href="http://www.beian.miit.gov.cn">浙ICP备15019865号-1</a>
						</div>
						<div class="company_infoDetail_text">公安部备案号：33010602001517</div>
					</div>
					<div class="company_infoContect">
						<div>
							<div class="company_infoContect_head">联系我们</div>
							<div class="company_infoContect_title">服务热线</div>
							<div class="company_infoContect_text">0571-87357305</div>
							<div class="company_infoContect_title">联系邮箱</div>
							<div class="company_infoContect_text">zjax@ansuw.com</div>
						</div>

					</div>
					<div class="lf">
						<div class="yuan"><img src="/static/img/img_call.png" alt="智慧农贸" /></div>
						<div class="lftext">
							<img src="/static/img/logo_call.png" alt="智慧农贸" />
							<p class="">全国免费电话</p>
						</div>
						<p class="dianhua">0571- 87357305</p>
						<div class="heng"></div>
						<div class="lftext" style="margin-bottom: .04rem;">
							<img src="/static/img/logo_time.png" alt="智慧农贸" />
							<p class="">服务时间</p>
						</div>
						<p class="shijian">全天</p>
						<p class="shijian">24小时服务</p>
					</div>
				</div>
			</footer>-->
		</div>

		<div class="yd" v-if="!pc">
			<div class="logoTop flexY">
				<div class="logo">
					<img src="/static/img/logo.png" alt="智慧农贸" />
					<div class="xian"></div>
					<div class="logoR">
						<p>国家高新技术企业</p>
						<p>全栈追溯技术服务商</p>
					</div>
				</div>
			</div>
			<div>
				<img style="width: 100%;" src="/static/img/img_home_banner@2x.png" alt="智慧农贸" />
			</div>
			<div class="content1 fangan">
				<div class="">
					<p class="biaoti">每个市场情况不同 <br>数字化升级解决方案不同</p>
					<div class="imgTextBox">
						<div><img src="/static/img/img_Solution@2x.png" alt="智慧农贸" /></div>
						<div class="">
							<p>浙江安宣，帮助每个有意向的市场量身定制数字化升级方案;</p>
							<p>努力实现监管者、举办者、经营者、消费者各方需求的兼容并包;</p>
							<p>市场规模不同、经营方式不同、投入预算不同，解决方案自然不同。</p>
						</div>
					</div>
				</div>
			</div>
			<div class="content2 flexY content1 bjh mokuai" style="padding-left:0;padding-right: 0;padding-bottom: 0;">
				<div class="x">
					<p class="biaoti fz42">100+功能模块自由组合</p>
					<div class="swiper-container bjh">
						<div class="swiper-wrapper">
							<div class="swiper-slide">
								<div class="swiperBox" v-for="(item,index) in ydiocBox" :key="'mokuai'+index"><img :src="item.src" alt="智慧农贸" />
									<div>{{item.name}}</div>
								</div>
							</div>
							<div class="swiper-slide">
								<div class="swiperBox" v-for="(item,index) in ydiocBox1" :key="'mokuai1'+index"><img :src="item.src" alt="智慧农贸" />
									<div>{{item.name}}</div>
								</div>
							</div>
							<div class="swiper-slide">
								<div class="swiperBox" v-for="(item,index) in ydiocBox2" :key="'mokuai2'+index"><img :src="item.src" alt="智慧农贸" />
									<div>{{item.name}}</div>
								</div>
							</div>
						</div>
						<!-- Add Pagination -->
						<div class="swiper-pagination"></div>
					</div>
				</div>
			</div>
			<div class="content2 flexY content1 zuhe">
				<div class="x">
					<p class="biaoti fz42">众多品牌智能硬件任意组合</p>
					<ul class="iocBox">
						<li v-for="(item,index) in ydzuhe" :key="'zuhe'+index">
							<img :src="item.src" alt="智慧农贸" />
							<p v-text="item.name"></p>
						</li>
					</ul>
				</div>
			</div>
			<div class="content2 flexY content1 bjh anli" style="padding-bottom: 0;">
				<div class="x">
					<p class="biaoti">他们都已升级智慧农贸</p>
					<ul class="iocBox">
						<li v-for="(item,index) in ydanli" :key="'anli'+index">
							<img :src="item.src" alt="智慧农贸" />
							<div class="bottomBox">
								<p v-text="item.name"></p>
							</div>
						</li>
					</ul>
					<a class="gengduo" href="http://www.ax168.com/market">更多案例</a>
				</div>
			</div>
			<div class="content2 flexY content1  fuwu">
				<div class="x">
					<p class="biaoti">360°全方位一站式服务</p>
					<ul class="iocBox" style="justify-content: space-around;">
						<li v-for="(item,index) in ydfuwu" :key="'fuwu'+index">
							<img :src="item.src" alt="智慧农贸" />
							<div>
								<p class="p1" v-text="item.name"></p>
								<p class="p2" v-text="item.text"></p>
							</div>
						</li>
					</ul>
				</div>
			</div>
			<div class="lianxi">
				<div>
					<p>现在联系我们，赢战智慧农贸新时代！</p>
					<a href="tel:0571-87357305">立即联系</a>
				</div>
			</div>

			<footer style="background-color:#162037;">
				<div>
					<p class="footerP mb45"><span class="span1">联系我们</span>（9:00-18:00，法定节假日除外）</p>
					<p class="footerP mb24">服务热线：
						<a class="span2" href="tel:0571-87357305">0571-87357305</a>
					</p>
					<p class="footerP ">公司邮箱：zjax@ansuw.com</p>
					<a href="" class="indexImg"><img src="/static/img/logo_bottom@2x.png" alt="智慧农贸" /></a>
					<p class="footerP mb24">地址：浙江省杭州市西湖区玉西园八路11号一期D座506-507</p>
					<p class="footerP mb24" style="cursor: pointer" @click="handNavGx">{{ICP_text}}</p>

					<p class="footerP mb24">公安部备案号：33010602001517</p>
				</div>

			</footer>
			<div class="bottom" style="background-color:#162037;">浙江安宣信息技术有限公司</div>
		</div>

	</div>
</template>

<script>
	import Swiper from 'swiper'
	import 'swiper/dist/css/swiper.min.css'
	export default {
		data() {
			return {
				navBarFixed: false,
				gengduo: false,
				pc: true,
				TopNav: 1,
				imgText: [
				  {

					classname: "li li1",
					text: '20余种营销方案全场景覆盖',
					show: false
				}, {
					classname: "li li2",
					text: '六十种报表直观展示全方位分析经营状况',
					show: false
				}, {
					classname: "li li3",
					text: '助力农贸数据化、精准化管理',
					show: false
				}],
				iocBox: [
				  {
					name: '数字驾驶舱',
					src: '/static/img/icon_1.png'
				}, {
					name: '智能称重',
					src: '/static/img/icon_2.png'
				}, {
					name: '信用公示',
					src: '/static/img/icon_3.png'
				}, {
					name: '智能巡查',
					src: '/static/img/icon_4.png'
				}, {
					name: '智能追溯',
					src: '/static/img/icon_5.png'
				}, {
					name: '公众查询',
					src: '/static/img/icon_6.png'
				}, {
					name: '数据分析',
					src: '/static/img/icon_7.png'
				}, {
					name: '会员中心',
					src: '/static/img/icon_8.png'
				}, {
					name: '智能检测',
					src: '/static/img/icon_9.png'
				}, {
					name: '网上菜场',
					src: '/static/img/icon_10.png'
				}, {
					name: '物联网',
					src: '/static/img/icon_11.png'
				}, {
					name: '视频监控',
					src: '/static/img/icon_12.png'
				}],
				ydiocBox1: [
				  {
					name: '统计报表',
					src: '/static/img/icon_13@2x.png'
				}, {
					name: '店铺管理',
					src: '/static/img/icon_14@2x.png'
				}, {
					name: '订单管理',
					src: '/static/img/icon_16@2x.png'
				}, {
					name: '配送管理',
					src: '/static/img/icon_16@2x.png'
				}, {
					name: '红包管理',
					src: '/static/img/icon_17@2x.png'
				}, {
					name: '市场优惠活动',
					src: '/static/img/icon_18@2x.png'
				}, {
					name: '消费投诉',
					src: '/static/img/icon_19@2x.png'
				}, {
					name: '广告管理',
					src: '/static/img/icon_20@2x.png'
				}, {
					name: '用户列表',
					src: '/static/img/icon_21@2x.png'
				}, {
					name: '风险管控',
					src: '/static/img/icon_22@2x.png'
				}, {
					name: '信息报备',
					src: '/static/img/icon_23@2x.png'
				}, {
					name: '采样管理',
					src: '/static/img/icon_24@2x.png'
				}],
				ydiocBox2: [
				  {
					name: '商家管理',
					src: '/static/img/icon_25@2x.png'
				}, {
					name: '准入管理',
					src: '/static/img/icon_26@2x.png'
				}, {
					name: '消息通知',
					src: '/static/img/icon_27@2x.png'
				}, {
					name: '销货台账',
					src: '/static/img/icon_28@2x.png'
				}, {
					name: '物业管理',
					src: '/static/img/icon_29@2x.png'
				}, {
					name: '消防管理',
					src: '/static/img/icon_30@2x.png'
				}, {
					name: '停车管理',
					src: '/static/img/icon_31@2x.png'
				}, {
					name: '疫情监测',
					src: '/static/img/icon_32@2x.png'
				}, {
					name: '市场招商',
					src: '/static/img/icon_33@2x.png'
				}, {
					name: '公共服务',
					src: '/static/img/icon_34@2x.png'
				}, {
					name: '设备管理',
					src: '/static/img/icon_35@2x.png'
				}, {
					name: '金融对接',
					src: '/static/img/icon_36@2x.png'
				}],
				ydiocBox: [
				  {
					name: '数字驾驶舱',
					src: '/static/img/icon_1.png'
				}, {
					name: '智能称重',
					src: '/static/img/icon_2.png'
				}, {
					name: '信息公示',
					src: '/static/img/icon_3.png'
				}, {
					name: '智能巡查',
					src: '/static/img/icon_4.png'
				}, {
					name: '智能追溯',
					src: '/static/img/icon_5.png'
				}, {
					name: '公众查询',
					src: '/static/img/icon_6.png'
				}, {
					name: '数据分析',
					src: '/static/img/icon_7.png'
				}, {
					name: '会员中心',
					src: '/static/img/icon_8.png'
				}, {
					name: '智能检测',
					src: '/static/img/icon_9.png'
				}, {
					name: '网上菜场',
					src: '/static/img/icon_10.png'
				}, {
					name: '统计报表',
					src: '/static/img/icon_11.png'
				}, {
					name: '视频监控',
					src: '/static/img/icon_12.png'
				}],
				ydzuhe: [
				  {
					name: '智慧农贸追溯电子秤',
					src: '/static/img/img_znyj_1@2x.png'
				}, {
					name: '商户信用公示屏',
					src: '/static/img/img_znyj_2@2x.png'
				}, {
					name: '放心农贸触摸一体机',
					src: '/static/img/img_znyj_3@2x.png'
				}, {
					name: '大数据中心',
					src: '/static/img/img_znyj_4@2x.png'
				}],
				anli: [
				  {
					name: '府苑新村农贸市场',
					src: '/static/img/img_1.png'
				}, {
					name: '磐安安文蔬菜市场',
					src: '/static/img/img_2.png'
				}, {
					name: '温岭果蔬批发市场',
					src: '/static/img/img_3.png'
				}, {
					name: '义乌词林菜场',
					src: '/static/img/img_4.png'
				}, {
					name: '东阳西门菜场',
					src: '/static/img/img_5.png'
				}, {
					name: '庆元香菇市场',
					src: '/static/img/img_6.png'
				}, {
					name: '陕西榆林市场',
					src: '/static/img/img_7.png'
				}, {
					name: '永康溪心菜场',
					src: '/static/img/img_8.png'
				}, {
					name: '山东威海市场',
					src: '/static/img/img_9.png'
				}],
				ydanli: [
				  {
					name: '府苑新村农贸市场',
					src: '/static/img/img_case_1@2x.png'
				}, {
					name: '义乌词林菜场',
					src: '/static/img/img_case_3@2x.png'
				}, {
					name: '磐安安文蔬菜市场',
					src: '/static/img/img_case_4@2x.png'
				}, {
					name: '温岭果蔬批发市场',
					src: '/static/img/img_case_5@2x.png'
				}, {
					name: '永康溪心菜场',
					src: '/static/img/img_case_2@2x.png'
				}, {
					name: '陕西榆林市场',
					src: '/static/img/img_case_6@2x.png'
				}, {
					name: '山东威海市场',
					src: '/static/img/img_case_7@2x.png'
				}, {
					name: '安徽智慧市场',
					src: '/static/img/img_case_8@2x.png'
				}, {
					name: '上海智慧菜场',
					src: '/static/img/img_case_9@2x.png'
				}],
				fuwu: [{
					name: '业务支持',
					src: '/static/img/img_business_1.png',
					text: '专属合作伙伴拓展经理提供业务支持和商务支持，帮助您在“产品质量安全信息化体系”领域取得成功。'
				}, {
					name: '培训支持',
					src: '/static/img/img_train_2.png',
					text: '为了用户更好的了解使用产品，安宣信息提供包括现场指导培训等多种服务。'
				}, {
					name: '专业技术支持',
					src: '/static/img/img_technology_3.png',
					text: '专项技术领域获得浙江安宣专业团队的技术支持，在垂直市场获得领先优势。'
				}],
				ydfuwu: [{
					name: '业务支持',
					src: '/static/img/img_business_1@2x.png',
					text: '专属合作伙伴拓展经理提供业务支持和商务支持，帮助您在“产品质量安全信息化体系”领域取得成功。'
				}, {
					name: '培训支持',
					src: '/static/img/img_train_2@2x.png',
					text: '为了用户更好的了解使用产品，安宣信息提供包括现场指导培训等多种服务。'
				}, {
					name: '专业技术支持',
					src: '/static/img/img_technology_3@2x.png',
					text: '专项技术领域获得浙江安宣专业团队的技术支持，在垂直市场获得领先优势。'
				}],
         ICP_text:'浙ICP备15019864号-1',
      ICP:{
        "http://localhost:8081":"测试",
        "http://www.ax168.com":"浙ICP备15019864号-4",
        "http://www.anxuan360.com":"浙ICP备15019864号-1",
        "http://www.axnm168.com":"浙ICP备15019864号-5",
        "http://www.aswnm.com":"浙ICP备15019864号-7",
        "http://www.axny168.com":"浙ICP备15019864号-6"
      },
			}
		},
		created: function() {
        let keys = Object.keys(this.ICP)
    let findIndex=  keys.findIndex(key=>{
       return  key.includes(window.location.host)
    })
    this.ICP_text =findIndex!=-1? this.ICP[keys[findIndex]]:this.ICP_text
			//			this.$emit('header', false);
			//			this.$emit('footer', false);
			if(this._isMobile()) {
				this.pc = false
				this.$emit('header', false);
				this.$emit('footer', false);
				this.$emit('footer1', true);
				this.$emit('footer2', false);
				//this.$emit('navfooter', false);
			} else {
				this.pc = true
				window.onbeforeunload = function() {
					document.documentElement.scrollTop = 0; //ie下
					document.body.scrollTop = 0; //非ie
				}
			}
      document.documentElement.style.fontSize =200+'px';
		},

		activated() {
			document.title = "安宣智慧农贸解决方案"
			document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px';
		},
		methods: {
      handNavGx(){
        window.open("https://beian.miit.gov.cn", '_blank')
      },
			goAnchor(selector) {
				this.$el.querySelector(selector).scrollIntoView({
					behavior: "smooth", // 平滑过渡
					block: "start" // 上边框与视窗顶部平齐。默认值
				});
			},
			clickGengduo() {
				this.gengduo = !this.gengduo
				if(this.gengduo) {
					this.iocBox = [{
						name: '数字驾驶舱',
						src: '/static/img/icon_1.png'
					}, {
						name: '智能称重',
						src: '/static/img/icon_2.png'
					}, {
						name: '信用公示',
						src: '/static/img/icon_3.png'
					}, {
						name: '智能巡查',
						src: '/static/img/icon_4.png'
					}, {
						name: '智能追溯',
						src: '/static/img/icon_5.png'
					}, {
						name: '公众查询',
						src: '/static/img/icon_6.png'
					}, {
						name: '数据分析',
						src: '/static/img/icon_7.png'
					}, {
						name: '会员中心',
						src: '/static/img/icon_8.png'
					}, {
						name: '智能检测',
						src: '/static/img/icon_9.png'
					}, {
						name: '网上菜场',
						src: '/static/img/icon_10.png'
					}, {
						name: '物联网',
						src: '/static/img/icon_11.png'
					}, {
						name: '视频监控',
						src: '/static/img/icon_12.png'
					}, {
						name: '统计报表',
						src: '/static/img/icon_13.png'
					}, {
						name: '店铺管理',
						src: '/static/img/icon_14.png'
					}, {
						name: '订单管理',
						src: '/static/img/icon_15.png'
					}, {
						name: '配送管理',
						src: '/static/img/icon_16.png'
					}, {
						name: '红包管理',
						src: '/static/img/icon_17.png'
					}, {
						name: '市场优惠活动',
						src: '/static/img/icon_18.png'
					}, {
						name: '消费投诉',
						src: '/static/img/icon_19.png'
					}, {
						name: '广告管理',
						src: '/static/img/icon_20.png'
					}, {
						name: '用户列表',
						src: '/static/img/icon_21.png'
					}, {
						name: '风险管控',
						src: '/static/img/icon_22.png'
					}, {
						name: '信息报备',
						src: '/static/img/icon_23.png'
					}, {
						name: '采样管理',
						src: '/static/img/icon_24.png'
					}, {
						name: '商家管理',
						src: '/static/img/icon_25.png'
					}, {
						name: '准入管理',
						src: '/static/img/icon_26.png'
					}, {
						name: '消息通知',
						src: '/static/img/icon_27.png'
					}, {
						name: '销货台账',
						src: '/static/img/icon_28.png'
					}, {
						name: '物业管理',
						src: '/static/img/icon_29.png'
					}, {
						name: '消防管理',
						src: '/static/img/icon_30.png'
					}, {
						name: '停车管理',
						src: '/static/img/icon_31.png'
					}, {
						name: '疫情监测',
						src: '/static/img/icon_32.png'
					}, {
						name: '市场招商',
						src: '/static/img/icon_33.png'
					}, {
						name: '公共服务',
						src: '/static/img/icon_34.png'
					}, {
						name: '设备管理',
						src: '/static/img/icon_35.png'
					}, {
						name: '金融对接',
						src: '/static/img/icon_36.png'
					}]
				} else {
					this.iocBox = [{
						name: '数字驾驶舱',
						src: '/static/img/icon_1.png'
					}, {
						name: '智能称重',
						src: '/static/img/icon_2.png'
					}, {
						name: '信用公示',
						src: '/static/img/icon_3.png'
					}, {
						name: '智能巡查',
						src: '/static/img/icon_4.png'
					}, {
						name: '智能追溯',
						src: '/static/img/icon_5.png'
					}, {
						name: '公众查询',
						src: '/static/img/icon_6.png'
					}, {
						name: '数据分析',
						src: '/static/img/icon_7.png'
					}, {
						name: '会员中心',
						src: '/static/img/icon_8.png'
					}, {
						name: '智能检测',
						src: '/static/img/icon_9.png'
					}, {
						name: '网上菜场',
						src: '/static/img/icon_10.png'
					}, {
						name: '物联网',
						src: '/static/img/icon_11.png'
					}, {
						name: '视频监控',
						src: '/static/img/icon_12.png'
					}]
				}
			},
			_isMobile() {
				let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
				return flag;
			},
			watchScroll() {
				var scrollTop =
					window.pageYOffset ||
					document.documentElement.scrollTop ||
					document.body.scrollTop;
				let a = this.$refs.a.offsetTop
				let b = this.$refs.b.offsetTop
				let c = this.$refs.c.offsetTop
				let d = this.$refs.d.offsetTop
				let e = this.$refs.e.offsetTop
				let height = this.$refs.element.offsetHeight
				//  当滚动超过 90 时，实现吸顶效果
				if(scrollTop + 70 >= a) {
					this.TopNav = 1
				}
				if(scrollTop + 70 >= b) {
					this.TopNav = 2
				}
				if(scrollTop + 70 >= c) {
					this.TopNav = 3
				}
				if(scrollTop + 70 >= d) {
					this.TopNav = 4
				}
				if(scrollTop + 80 >= e) {
					this.TopNav = 5
				}
				if(scrollTop > height) {
					this.navBarFixed = true;
				} else {
					this.navBarFixed = false;
				}

			}
		},
		mounted() {
			window.addEventListener("scroll", this.watchScroll);
			var j = 0
			var th = this

			setInterval(function() {
				for(var i = 0; i < th.imgText.length; i++) {
					th.imgText[i].show = false
				}
				th.imgText[j].show = true
				if(j == 2) {
					j = 0
				} else {
					j++
				}

			}, 2000)

			window.onresize = function() { //监听屏幕的改变
      // console.log(document.documentElement.clientWidth>1000,document.documentElement.style.fontSize)
      if(document.documentElement.clientWidth>1000){
        document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px';
      } else {
        document.documentElement.style.fontSize = 1000 / 7.5 + 'px';
      }

			};

			var swiper = new Swiper('.swiper-container', {
				slidesPerView: 'auto',
				pagination: '.swiper-pagination',
			});
		},
		components: {

		}
	}
</script>
<style>
	.navBarWrap {
		position: fixed;
		top: 0px;
		z-index: 99999999999999999;
		background-color: #fff;
		width: 100%;
	}

	.focuImg {
		position: relative;
		overflow: hidden;
	}

	.focuImg .li {
		background-color: #668fe7;
		position: absolute;
		border-radius: .3rem;
		color: #fff;
		font-size: .08rem;
		font-weight: 500;
		padding: .06rem .2rem .06rem .2rem;
		transition: all 2s;
		opacity: 0;
	}

	.focuImg .li1.active {
		transform: translateX(0px);
		opacity: 1;
	}

	.focuImg .li2.active {
		transform: translateY(0px);
		opacity: 1;
	}

	.focuImg .li3.active {
		transform: translateX(0px);
		opacity: 1;
	}

	.focuImg .li1 {
		transform: translateX(-100px);
		width: .5rem;
		left: .75rem;
		bottom: .8rem;
	}

	.focuImg .li2 {
		transform: translateY(-100px);
		width: .75rem;
		right: 2.3rem;
		bottom: 1.38rem;
	}

	.focuImg .li3 {
		transform: translateX(100px);
		width: .65rem;
		right: 0.1rem;
		bottom: 1rem;
		z-index: 999999999999999999;
	}

	.swiper-container-horizontal>.swiper-pagination-bullets,
	.swiper-pagination-custom,
	.swiper-pagination-fraction {
		bottom: .5rem;
	}

	.swiper-pagination-bullet {
		width: .08rem;
		height: .08rem;
		border-radius: 50%;
	}

	.swiper-pagination-bullet-active {
		background: #00C59F;
		width: .32rem;
		height: .08rem;
		border-radius: .4rem;
	}
</style>
<style scoped>
	.company_infoContect .guanzhu {
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(255, 255, 255, 1);
		margin-bottom: 12px;
	}

	.company_infoContect .wxHao {
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(255, 255, 255, 1);
		margin-top: 10px;
	}

	.pc {
		padding-top: 67px;
	}

	html,
	body {
		position: relative;
		height: 100%;
	}

	body {
		background: #eee;
		font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
		font-size: 14px;
		color: #000;
		margin: 0;
		padding: 0;
	}

	.swiper-container {
		width: 100%;
		height: 100%;
		padding-bottom: 1rem;
		background-color: rgba(248, 248, 248, 1);
	}

	.swiper-wrapper,
	.swiper-slide {
		background-color: rgba(248, 248, 248, 1);
	}

	.swiperBox {
		width: 33%;
		text-align: center;
		margin-bottom: .4rem;
		padding-left: .7rem;
		box-sizing: border-box;
		font-size: .2rem;
	}

	.swiperBox>img {
		margin: 0 auto;
		margin-bottom: .2rem;
		width: .7rem;
	}

	.swiperBox>div {
		white-space: nowrap;
	}

	.swiper-slide {
		text-align: center;
		font-size: 18px;
		width: 84%;
		flex-wrap: wrap;
		/* Center slide text vertically */
		display: -webkit-box;
		display: -ms-flexbox;
		display: -webkit-flex;
		display: flex;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		-webkit-justify-content: center;
		justify-content: center;
		-webkit-box-align: center;
		-ms-flex-align: center;
		-webkit-align-items: center;
		align-items: center;
	}
	/*.swiper-slide:nth-child(2n) {
		width: 60%;
	}

	.swiper-slide:nth-child(3n) {
		width: 40%;
	}
	*/
	.TopNav {
		display: flex;
    width: 100%;
    /* width: 1200px; */
    box-sizing: border-box;
    justify-content: center;
		box-shadow: 0px 14px 13px 0px rgba(112, 112, 149, 0.06);
    margin-bottom: 10px;
		/* padding-left: 450px; */
   /* float: right; */
	}


	.TopNav li.active {
		border-bottom: 1px solid #00C59F;
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: rgba(20, 20, 20, 1);

	}


	.TopNav li {
   /* flex: 1;
      flex-grow: 1; */
    flex-shrink: 0;
		cursor: pointer;
		width: 120px;
		text-align: center;
		margin: 0 30px;
		height: 68px;
		line-height: 68px;
		display: inline-block;
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(51, 51, 51, 1);
	}

	.indexImg {
		width: 1.53rem;
		margin-top: .7rem;
		margin-bottom: .44rem;
		display: block;
	}

	.indexImg>img {
		width: 100%;
	}

	.yd .bottom {
		height: .94rem;
		line-height: .94rem;
		text-align: center;
		font-size: .22rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(111, 116, 126, 1);
	}

	.fz42 {
		font-size: .42rem!important;
	}

	.lftext {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: .04rem;
	}

	.dianhua {
		width: .3rem;
		font-size: .06rem;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: rgba(255, 255, 255, 1);
		text-align: center;
		margin: 0 auto;
		margin-top: .05rem;
	}

	.shijian {
		width: .45rem;
		font-size: .05rem;
		font-family: Microsoft YaHei;
		color: #fff;
		text-align: center;
	}

	.heng {
		width: .27rem;
		height: 1px;
		background-color: #fff;
		margin: .06rem auto;
	}

	.lftext>img {
		margin-right: .03rem;
	}

	.lftext>p {
		font-size: .04rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(255, 255, 255, 1);
	}

	.lf .yuan>img {
		margin: 0 auto;
		display: block;
		width: 74%;
	}

	.lf {
		width: .45rem;
		height: 1.16rem;
		background: linear-gradient(0deg, rgba(0, 184, 148, 1), rgba(0, 197, 159, 1));
		border-radius: .23rem .23rem 0px 0px;
		position: fixed;
		right: 0;
		top: 40%;
		padding: .06rem 0;
		box-sizing: border-box;
	}

	.lianxi {
		height: .92rem;
		display: flex;
		align-items: center;
		background: url('/static/img/img_contactus_bg.png') no-repeat;
		background-size: cover;
		justify-content: center;
	}

	.yd .lianxi {
		height: 3.26rem;
	}

	.lianxi p {
		font-size: .11rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(254, 254, 254, 1);
		text-align: center;
	}

	.yd .lianxi p {
		font-size: .32rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(254, 254, 254, 1);
		text-align: center;
	}

	.yd .lianxi a {
		width: 3.06rem;
		height: .76rem;
		font-size: .28rem;
		line-height: .76rem;
		margin-top: .54rem;
	}

	.lianxi a {
		display: flex;
		width: .69rem;
		height: .18rem;
		line-height: .18rem;
		background: rgba(255, 255, 255, 1);
		border-radius: 1px;
		font-size: .05rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(73, 141, 255, 1);
		margin: 0 auto;
		display: flex;
		justify-content: center;
		margin-top: .12rem;
	}

	.gengduo {
		display: block;
		cursor: pointer;
		width: .56rem;
		height: .18rem;
		border: 1px solid rgba(0, 197, 159, 1);
		text-align: center;
		line-height: .18rem;
		font-size: .05rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(0, 197, 159, 1);
		margin: .2rem auto;
		margin-top: .1rem;
	}

	.yd .gengduo {
		display: block;
		width: 3.16rem;
		height: .76rem;
		font-size: .3rem;
		line-height: .76rem;
		margin-top: .56rem;
		margin-bottom: .42rem;
	}

	.gengduo:hover {
		color: #fff;
		background-color: rgba(0, 197, 159, 1);
	}

	.x {
		width: 1200px;
	}

	.mb45 {
		margin-bottom: .45rem;
	}

	.yd .x {
		width: 100%;
	}

	.content1 {
		padding: .3rem;
		position: relative;
	}

	.content1 .mddw {
		position: absolute;
		top: -68px;
		width: 100%;
		height: 68px;
		left:0px;
		z-index: -1;
	}

	.yd .content1 {
		padding: .9rem .45rem;
	}

	.yd .content1.zuhe,
	.yd .content1.mokuai,
	.yd .content1.fangan {
		padding-bottom: .5rem;
	}

	.yd .content1.fuwu,
	.yd .content1.zuhe,
	.yd .content1.fangan {
		background-color: #fff;
	}

	.mokuai .gengduo {
		margin-bottom: 0;
		background-color: rgba(0, 197, 159, 1);
		color: #fff;
	}

	.mokuai .gengduo img {
		display: inline-block;
		margin-left: .03rem;
	}

	.bjh {
		background: rgba(248, 248, 248, 1);
	}

	.xian {
		width: 1px;
		height: .11rem;
		background: rgba(99, 104, 108, 1);
		margin: 0 .03rem;
	}

	.yd .xian {
		width: 1px;
		height: .45rem;
		background: rgba(99, 104, 108, 1);
		margin: 0 .1rem;
	}

	.flexY {
		display: flex;
		align-items: center;
	}

	.logoTop .logo {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.logo>img {
		width: .45rem;
	}

	.yd .logo>img {
		width: 2.2rem;
	}

	.logoTop {
		background-color: #fff;
		height: .3rem;
		padding-left: .11rem;
	}

	.yd .logoTop {
		background-color: #fff;
		height: 1.5rem;
		padding-left: .14rem;
	}

	.logoR p {
		font-family: inpin heiti;
		font-size: .05rem;
	}

	.yd .logoR p {
		font-family: inpin heiti;
		font-size: .2rem;
		color: #141414;
	}

	.content1 {
		justify-content: center;
	}

	.imgTextBox {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.yd .imgTextBox {
		display: block;
		width: 100%;
	}

	.imgTextBox p {
		font-size: .08rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(50, 50, 51, 1);
		line-height: .16rem;
	}

	.pc .zuhe li {
		width: 1200px;
		height: 400px;
		background: rgba(255, 255, 255, 1);
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 30px;
	}

	.pc .zuhe li .zuheBox {
		display: flex;
		align-items: center;
	}

	.fbiaoti {
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(50, 50, 51, 1);
		margin-top: 23px;
		text-align: center;
		margin-bottom: 100px;
	}

	.JJFA {
		width: 1050px;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
	}

	.topxian {
		width: 74px;
		height: 1px;
		background: #C8C7D8;
		margin-bottom: 22px;
		margin-top: 50px;
	}

	.JJFA .l .pTop {
		font-size: 30px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(48, 143, 255, 1);
		margin-bottom: 37px;
	}

	.JJFA .l {
		width: 340px;
	}

	.JJFA .l .Plist {
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(50, 50, 51, 1);
		position: relative;
		padding-left: 20px;
		line-height: 35px;
		margin-bottom: 49px;
	}

	.JJFA .l .Plist:before {
		content: "";
		position: absolute;
		left: 0;
		top: 10px;
		width: 8px;
		height: 16px;
		background: rgba(48, 143, 255, 1);
		border-radius: 4px;
	}

	.pc .zuhe li .zuheBox .rtext {
		margin-left: 144px;
	}

	.pc .zuhe li .zuheBox .rtext .tdNav {
		margin-top: 46px;
		display: flex;
	}

	.pc .zuhe li .zuheBox .rtext .tdNav>div {
		width: 80px;
		margin-right: 36px;
	}

	.pc .zuhe li .zuheBox .rtext .tdNav>div:last-child {
		margin-right: 0;
	}

	.pc .zuhe li .zuheBox .rtext .tdNav img {
		width: 80px;
		height: 80px;
	}

	.pc .zuhe li .zuheBox .rtext .tdNav p {
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(51, 51, 51, 1);
		text-align: center;
		margin-top: 24px;
	}

	.pc .zuhe li .zuheBox .rtext p:nth-child(1) {
		font-size: 24px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: rgba(44, 58, 70, 1);
	}

	.pc .zuhe li .zuheBox .rtext p:nth-child(2) {
		margin-top: 18px;
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(44, 58, 70, 1);
	}

	.pc .zuhe li .zuheBox>div>img {
		width: 224px;
		height: 298px;
	}

	.pc .zuhe li .rioc {
		box-sizing: border-box;
		position: absolute;
		right: 20px;
		top: 20px;
		width: 122px;
		height: 42px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 5px 14px 4px rgba(91, 140, 223, 0.09);
		border-radius: 21px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-left: 20px;
		padding-right: 5px;
	}

	.pc .zuhe li .rioc span {
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		line-height: 42px;
	}

	.pc .zuhe li:nth-child(1) .rioc span {
		color: #5AA6FF;
	}

	.pc .zuhe li:nth-child(2) .rioc span {
		color: #5BCA54;
	}

	.pc .zuhe li:nth-child(3) .rioc span {
		color: #948FFF;
	}

	.pc .zuhe li .rioc img {
		width: 36px;
		height: 36px;
		margin: 0;
	}

	.yd .imgTextBox p {
		font-size: .3rem;
		line-height: .54rem;
		color: #323233;
	}

	.yd .fangan .imgTextBox p {
		margin-bottom: .41rem;
	}

	.imgTextBox>div:first-child {
		margin-right: .39rem;
		width: 3.3rem;
	}

	.yd .imgTextBox>div:first-child {
		width: 100%;
		margin: 0;
		margin-bottom: .74rem;
	}

	.imgTextBox>div:first-child>img {
		width: 100%;
	}

	.iocBox {
    min-width: 1200px;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.mokuai .iocBox li {
    min-width: 140px;
		width: 16.66%;
		margin-bottom: .2rem;
	}

	.iocBox li {
		position: relative;
	}

	.yd .iocBox li {
		width: 33%;
		text-align: center;
		margin-bottom: .51rem;
	}

	.yd .mokuai .iocBox li>img {
		width: .8rem;
		height: .64rem;
	}

	.yd .fuwu .iocBox li>img {
		width: 2rem;
	}

	.yd .fuwu .iocBox li {
		width: 100%;
		margin-bottom: .79rem;
	}

	.yd .anli .iocBox li {
		width: 100%;
	}

	.yd .anli .iocBox li>img {
		width: 100%;
	}

	.yd .zuhe .iocBox li {
		width: 48%;
	}

	.yd .zuhe .iocBox li>img {
		width: 100%;
	}

	.yd .iocBox li>img {
		display: block;
		margin: 0 auto;
	}

	.iocBox li img {
		display: block;
		margin: 0 auto;
	}

	.iocBox li p {
		text-align: center;
		font-size: .07rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(60, 68, 79, 1);
		line-height: .09rem;
		margin-top: .12rem;
	}

	.yd .iocBox li p {
		font-size: .22rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(60, 68, 79, 1);
		line-height: .22rem;
	}

	.yd .mokuai .iocBox li p {
		margin-top: .2rem;
	}

	.yd .anli .iocBox li .bottomBox {
		width: 100%;
		height: 1.3rem;
		border: 0px solid #fff;
		background-color: #fff;
		display: flex;
		align-items: center;
		padding-left: .38rem;
		box-sizing: border-box;
	}

	.anli .iocBox li .bottomBox {
		width: 100%;
		height: .3rem;
		background-color: #fff;
		display: flex;
		align-items: center;
		box-sizing: border-box;
	}

	.anli .iocBox li .bottomBox p {
		margin-top: 0;
		height: .15rem;
		background-size: 100% 100%;
		font-size: .06rem;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: rgba(255, 255, 255, 1);
		line-height: .15rem;
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(20, 20, 20, 1);
	}

	.yd .anli .iocBox li .bottomBox p {
		margin-top: 0;
		height: .5rem;
		background: url('/static/img/img_case_name_bg_8.png') center no-repeat;
		background-size: 100% 100%;
		font-size: .28rem;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: rgba(255, 255, 255, 1);
		line-height: .5rem;
		padding: 0 .2rem;
		color: #fff;
	}

	.fuwu li {
		width: 230px;
		text-align: center;
	}

	.fuwu li p {
		margin-top: 0;
	}

	.fuwu li .p1 {
		font-size: 22px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(32, 32, 32, 1);
		margin-top: 21px;
		margin-bottom: 33px;
	}

	.yd .fuwu li .p1 {
		font-size: .32rem;
		color: rgba(51, 51, 51, 1);
		line-height: .32rem;
		margin-top: .2rem;
		margin-bottom: .24rem;
	}

	.fuwu li .p2 {
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(32, 32, 32, 1);
		line-height: 25px;
	}

	.yd .fuwu li .p2 {
		width: 5.04rem;
		font-size: .26rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(162, 162, 162, 1);
		text-align: center;
		line-height: .38rem;
		margin: 0 auto;
		text-align: center;
	}

	.yd .zuhe .iocBox li p {
		margin-top: 0;
		width: 100%;
		height: .26rem;
		line-height: .26rem;
		text-align: center;
		font-size: .06rem;
		box-sizing: border-box;
		font-family: Microsoft YaHei;
		border: 1px solid rgba(243, 246, 249, 1);
	}

	.yd .zuhe .iocBox li p {
		margin-top: 0;
		width: 100%;
		height: 0.93rem;
		line-height: 0.93rem;
		text-align: center;
		font-size: .28rem;
		box-sizing: border-box;
		font-family: Microsoft YaHei;
		border: 1px solid rgba(243, 246, 249, 1);
		background-color: #fff;
	}

	.yd .anli .iocBox li {
		margin-bottom: .3rem;
	}

	.anli .iocBox li {
		margin-bottom: .08rem;
	}

	.biaoti {
		font-size: .14rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(50, 50, 51, 1);
		margin-bottom: .29rem;
		text-align: center;
	}

	.yd footer {
		padding: .8rem .49rem;
		border: 2px solid rgba(28, 41, 70, 1);
	}

	.footerP {
		font-size: .24rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(164, 168, 176, 1);
	}

	.footerP .span1 {
		color: #fff;
	}

	.footerP .span2 {
		color: #00C59F;
	}

	.mb24 {
		margin-bottom: .24rem
	}

	.yd .biaoti {
		font-size: .44rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(50, 50, 51, 1);
		margin-bottom: .29rem;
		text-align: center;
		margin-bottom: .92rem;
	}

	.company_info {
		width: 4.3rem;
		margin: 0 auto;
		min-width: 1200px;
		height: 295px;
		color: #6f747e;
		font-size: 16px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.company_info .company_infoDetail .company_infoDetail_logo {
		width: 153px;
		height: 50px;
		margin-bottom: 20px;
	}

	.company_info .company_infoDetail .company_infoDetail_text {
		margin-bottom: 12px;
	}

	.company_info .company_infoContect {
		display: flex;
	}

	.company_info .company_infoContect .company_infoContect_head {
		color: #ffffff;
		font-size: 18px;
		margin-bottom: 20px;
	}

	.company_info .company_infoContect .company_infoContect_title {
		margin-bottom: 12px;
	}

	.company_info .company_infoContect .company_infoContect_text {
		color: #ffffff;
		font-size: 20px;
		margin-bottom: 12px;
	}
</style>



// WEBPACK FOOTER //
// src/components/publicity.vue